import React, { useState, useEffect } from 'react';
import { products } from '../data/mockData';
import ProductCard from './ProductCard';
import SafeIcon from '../common/SafeIcon';

export default function ProductGrid() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate initial platform load
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="shop" className="py-24 bg-white min-h-[600px]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-6">
          <div>
            <span className="text-red-600 font-bold uppercase tracking-[0.2em] text-xs mb-3 block">Professional Grade</span>
            <h2 className="text-4xl md:text-5xl font-black text-zinc-900 tracking-tighter">ESSENTIAL TOOLS</h2>
          </div>
          <div className="flex gap-4">
            <select className="bg-zinc-50 border border-zinc-200 px-4 py-2 font-bold text-xs uppercase tracking-widest focus:outline-none focus:border-red-600">
              <option>Sort By: Popular</option>
              <option>Price: Low to High</option>
              <option>Price: High to Low</option>
            </select>
          </div>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-16">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="animate-pulse">
                <div className="aspect-[4/5] bg-zinc-100 mb-6" />
                <div className="h-4 bg-zinc-100 w-3/4 mb-4" />
                <div className="h-4 bg-zinc-100 w-1/2" />
              </div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-16">
            {products.map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}